import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import SearchFactory from '../SearchFactory/SearchFactory';
import SearchUserByEC from '../SearchUserByEC/SearchUserEC';

const EditPayrollPic = ({ handleClose, show, modalInfo , onEdit, token}) => {
    const [payrollPicName, setPayrollPicName] = useState('');
    const [payrollPicBadgeId, setPayrollPicBadgeId] = useState('');
    const [payrollPicUsername, setPayrollPicUsername] = useState('');
    const [payrollPicEmail, setPayrollPicEmail] = useState('');
    const [payrollPicId, setPayrollPicId] = useState('');
    const [groupFactories, setGroupFactories] = useState([]);
    const [modifiedBy, setModifiedBy] = useState('');
    const [status, setStatus] = useState('');

    useEffect(() => {
        setPayrollPicId(modalInfo.id); 
        setGroupFactories(modalInfo.factory);
        setStatus('1');
        const email = localStorage.getItem('email');
        const username = email.split('@')[0];
        setModifiedBy(username);
    }, [modalInfo]);

    // const getPermissionID = (permissionID) => {
    //     setPermissionTypes(permissionID);
    // };

    const onSubmit = (e) => {
        e.preventDefault();
        
        const factoryId = groupFactories.map((item) => item.id).toString();
        const factoryName = groupFactories.map((item) => item.factory).toString();

        if (!payrollPicUsername) {
            alert('Please select a payroll PIC');
        } else if (!factoryId || !factoryName) {
            alert('Please select at least a factory');
        } else {
            //! change
            // const userName = factories
            //     .map((item) => item.formalName)
            //     .toString();
            // const permission = permissionTypes.toString();
            onEdit({
                status,
                factoryId,
                payrollPicId,
                modifiedBy
            });
        }
    };

// get user details
const getPayrollPicDetails = (payrollPicProp) => {
    if (payrollPicProp) {
        setPayrollPicName(payrollPicProp.name)
        setPayrollPicBadgeId(payrollPicProp.badgeId)
        setPayrollPicEmail(payrollPicProp.email)
        setPayrollPicUsername(payrollPicProp.username)
        console.log(payrollPicProp)
    }
    else {
        setPayrollPicName('');
        setPayrollPicBadgeId('');
        setPayrollPicEmail('');
        setPayrollPicUsername('');

    }
}


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Edit Payroll PIC
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    {/* <Form.Group className='mb-3'>
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your group name here...'
                            style={{ width: '100%' }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Form.Group> */}
                      <Form.Group className='mb-3'>
                        <Form.Label>Payroll PIC</Form.Label>
                        <SearchUserByEC
                            getSuperiorDetails={getPayrollPicDetails}
                            token={token}
                            hodUsername={modalInfo.username}
                            isDisabled={true}/>
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Factories</Form.Label>
                        <SearchFactory 
                            setFactories={setGroupFactories} 
                            modalInfo={modalInfo}
                        />
                    </Form.Group>
                    {/* <Form.Group className='mb-3'>
                        <Form.Label>Permission Settings</Form.Label>
                        <PermissionsDropdown
                            getPermissionID={getPermissionID}
                        />
                    </Form.Group> */}
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditPayrollPic;
